import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/passkeys/usePasskeyQueryKeys.ts
var t = e("passkeys", { list: () => ["list"] });
//#endregion
export { t as passkeyQueryKeys };
